export const BASEURL = process.env.REACT_APP_API_BASE || "";
